/**
 * <SandboxModeBadge /> — locked green-vs-blue pill primitive per
 * M3X.GOV.5 §4.1. Used on the integrations hub + every per-portal
 * page header.
 */

import { useTranslation } from "react-i18next";

export interface SandboxModeBadgeProps {
  mode: "sandbox" | "production";
}

export function SandboxModeBadge({ mode }: SandboxModeBadgeProps) {
  const { t } = useTranslation();
  const isSandbox = mode === "sandbox";
  return (
    <span
      data-testid="sandbox-mode-badge"
      className={[
        "inline-flex items-center gap-1.5 rounded-full px-3 py-1",
        "text-xs font-medium ring-1",
        isSandbox
          ? "bg-emerald-50 text-emerald-700 ring-emerald-200"
          : "bg-blue-50 text-blue-700 ring-blue-200",
      ].join(" ")}
    >
      <span
        aria-hidden
        className={[
          "h-1.5 w-1.5 rounded-full",
          isSandbox ? "bg-emerald-500" : "bg-blue-500",
        ].join(" ")}
      />
      {isSandbox
        ? t("gov.sandbox_mode_on", "Sandbox mode ON")
        : t("gov.production_mode_on", "Production mode ON")}
    </span>
  );
}

export default SandboxModeBadge;
